module.exports = __webpack_public_path__ + "static/media/CEA_TAUX&CONDITIONS.03450690.pdf";